import { z } from "zod";

export const currentUserResponseSchema = z.object({
  isOperator: z.boolean(),
  userName: z.string(),
  organizationRootName: z.string().nullish(),
  creationDateTime: z.string().nullish(),
  organizationAllSitesCount: z.number().nullish(),
  userPerimeterSitesCount: z.number().nullish(),
  userPerimeterApplianceCount: z.number().nullish(),
});

export type TCurrentUser = z.infer<typeof currentUserResponseSchema>;
